import { Card, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../MainPages.css';

export default function Institucional() {
    return (
        <Row>
            <Col xs="12">
                <p><small>Você está em Institucional</small></p>
                <h1>Institucional</h1>
                <h3>Consulte:</h3>
            </Col>
            <Col xs="12">
                <Link to="/institucional/atribuicoes">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Atribuições da Alepe
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <a href="https://www.alepe.pe.gov.br/estrutura/" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Estrutura Legislativa
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://www.alepe.pe.gov.br/estrutura-administrativa/" target='_blank'>
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Estrutura Administrativa
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://www.alepe.pe.gov.br/parlamentares/" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Parlamentares
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <Link to="/institucional/atendimento">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Atendimento ao Público
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <a href="/institucional/nossos-servicos">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Nossos Serviços
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <a href="https://dadosabertos.alepe.pe.gov.br" target="_blank">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Portal de Dados Abertos
                        </Card.Body>
                    </Card>
                </a>
            </Col>
            <Col xs="12">
                <Link to="/institucional/informacoes-classificadas">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Informações Classificadas em Grau de Sigilo
                        </Card.Body>
                    </Card>
                </Link>
            </Col>
            <Col xs="12">
                <Link to="/institucional/informacoes-desclassificadas">
                    <Card style={{ width: '100%' }}>
                        <Card.Body style={{ display: 'flex', alignItems: 'center' }}>
                            <i style={{ fontSize: '60%', paddingRight: '10px' }} className="fa-solid fa-chevron-right"></i>
                            Informações Desclassificadas em Grau de Sigilo
                        </Card.Body>
                    </Card>
                </Link>
            </Col>

        </Row>
    );
}
